import React from 'react';
import AdminRegenerationReport from './admin/AdminRegenerationReport';

/** Court App regenerations — same report as Court Admin. */
const Regenerations = () => <AdminRegenerationReport />;

export default Regenerations;
